import { Link } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-100 flex flex-col">
      <SiteHeader />
      <main className="flex-1 pt-16 md:pt-[72px]">
        <div className="mx-auto flex max-w-2xl flex-col items-center px-4 py-24 text-center md:py-32">
          <span className="flex items-center justify-center w-16 h-16 rounded-full bg-background-200 text-foreground-400 mb-5">
            <i className="ri-emotion-sad-line text-3xl"></i>
          </span>
          <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">页面走丢了</h1>
          <p className="mt-3 text-sm md:text-base text-foreground-500">
            你访问的页面可能已被移除，或者链接有误。不如先回首页，看看最近有什么好剧吧。
          </p>
          <div className="mt-7 flex flex-col sm:flex-row gap-3">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 h-11 px-6 rounded-md bg-accent-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-accent-600 transition-colors"
            >
              <i className="ri-home-4-line"></i>
              返回首页
            </Link>
            <Link
              to="/category"
              className="inline-flex items-center justify-center gap-2 h-11 px-6 rounded-md border border-background-300 bg-background-50 text-sm font-medium text-foreground-800 whitespace-nowrap hover:border-accent-300 hover:text-accent-600 transition-colors"
            >
              浏览影视分类
            </Link>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}